/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum MT4ServerType {
  demo = "demo",
  real = "real",
}


// Supported currencies
export enum Currency {
  BCH = "BCH",
  BTC = "BTC",
  CHF = "CHF",
  CUD = "CUD",
  DASH = "DASH",
  DKK = "DKK",
  ETH = "ETH",
  EUR = "EUR",
  GBP = "GBP",
  LTC = "LTC",
  NOK = "NOK",
  PLN = "PLN",
  SEK = "SEK",
  USD = "USD",
}


// Forex-only account subtype (basic/black/bonus)
export enum AccountSubtype {
  aff001 = "aff001",
  aff002 = "aff002",
  ai = "ai",
  basic = "basic",
  black = "black",
  bonds = "bonds",
  bonus = "bonus",
  cent = "cent",
  classic = "classic",
  ib_wallet = "ib_wallet",
  invest_plus = "invest_plus",
  master = "master",
  mt5Raw = "mt5Raw",
  mt5Std = "mt5Std",
  mt5Vip = "mt5Vip",
  premium = "premium",
  raw = "raw",
  raw_grow = "raw_grow",
  raw_pro = "raw_pro",
  raw_trial = "raw_trial",
  sc_sub = "sc_sub",
  sub = "sub",
  swiss11 = "swiss11",
  swiss4 = "swiss4",
  swiss5 = "swiss5",
  swiss8 = "swiss8",
}


export enum Locale {
  ar = "ar",
  cs = "cs",
  da = "da",
  de = "de",
  el = "el",
  en = "en",
  es = "es",
  fi = "fi",
  fr = "fr",
  hi = "hi",
  hu = "hu",
  id = "id",
  it = "it",
  ja = "ja",
  ko = "ko",
  mn = "mn",
  ms = "ms",
  nl = "nl",
  no = "no",
  ph = "ph",
  pl = "pl",
  pt = "pt",
  ro = "ro",
  ru = "ru",
  sv = "sv",
  th = "th",
  tr = "tr",
  vi = "vi",
  zh = "zh",
}


export interface closedPositionsQueryVariables {
  login: number,
  server: MT4ServerType,
  limit: number,
  offset: number,
};

export interface closedPositionsQuery {
  closedPositions:  Array< {
    // Trading ticket
    id: string | null,
    // Close Time
    closeTime: string | null,
    // Symbol
    symbol: string | null,
    // Profit
    profit: number | null,
    // type
    type: string | null,
    // Invested amount
    investment: number | null,
    // Trade leverage
    leverage: number | null,
    // Open Price
    openPrice: number | null,
    // Close Price
    closePrice: number | null,
    // Volume
    volume: number | null,
    // Commission
    commission: number | null,
    // Swap
    swaps: number | null,
    // Taxes
    taxes: number | null,
  } | null > | null,
};

export interface getAllowedLeveragesQueryVariables {
  accountId: number,
};

export interface getAllowedLeveragesQuery {
  getAllowedLeverages: Array< number | null > | null,
};

export interface getFavouritesQuery {
  viewer: ( {
    } | {
      // Client ID
      id: number | null,
      tradingConfig:  {
        // Favourite assets
        favourites: Array< string | null > | null,
      },
    } | {
    } | {
    }
  ) | null,
};

export interface updateFavouritesMutationVariables {
  favourites: Array< string | null >,
};

export interface updateFavouritesMutation {
  // Favourite assets
  updateFavourites:  {
    // Favourite assets
    favourites: Array< string | null > | null,
  } | null,
};

export interface viewerQuery {
  viewer: ( {
    } | {
      // Client ID
      id: number | null,
      // Email address
      email: string | null,
      // Client locale - used to set currency, language, timezone
      locale: Locale | null,
      // Company client belongs to
      company: string | null,
      isPhoneVerificationRequired: boolean | null,
      // Accounts belonging to this client
      accounts:  Array<( {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerBDSwissVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
          // Coupons paid for bonds on this account
          coupons:  Array< {
            // Bond symbol on MT4
            bond: string | null,
            // Ticket on MT4
            ticket: number | null,
            // Date coupon was paid
            date: string | null,
            // Amount that was paid
            amount: number | null,
          } | null > | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMSMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMSMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5Account",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5DemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5MauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5MauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5VanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5VanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusAccountBDX",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PortfolioManagementAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PortfolioManagementMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexPremiumMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexPremiumVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicSkyGroundAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicSkyGroundDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicLydianAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicLydianDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5TauromarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        }
      ) | null > | null,
    } | {
    } | {
      accounts:  Array<( {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMFundManagerVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerBDSwissVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "AIPAMMMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerSwissMarketsVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMFundManagerVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PAMMSMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondMauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "BondVanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMSMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMSMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "MAMAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5Account",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5DemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5MauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5MauritiusDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5VanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5VanuatuDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawBDSwissVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMauritiusAccountBDX",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PortfolioManagementAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "PortfolioManagementMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexPremiumMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexPremiumVanuatuAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicSkyGroundAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicSkyGroundDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicEquityFlowDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerEquityFlowAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicLydianAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicLydianDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexMT5TauromarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsAsiaAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsDemoAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexRawTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "CentTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
        } | {
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "IntroducingBrokerTauroMarketsAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        } | {
          // Account ID
          id: number | null,
          login: string | null,
          // Balance for this account
          balance: number | null,
          // Currency in which account is lead
          currency: Currency | null,
          metaTraderApiUrl: string | null,
          isArchived: boolean | null,
          hidden: boolean | null,
          // Account Subtype
          accountSubtype: AccountSubtype | null,
          // Swap Free account
          swapFree: boolean | null,
          __typename: "ForexClassicTauroMarketsMauritiusAccount",
          isDemo: boolean | null,
          symbolOverrides:  {
            symbol: string | null,
            marginDivider: number | null,
          } | null,
        }
      ) | null > | null,
    }
  ) | null,
};

export type AccountDetailsFragment = ( {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMFundManagerAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMFundManagerAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMauritiusDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexAsiaAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexVanuatuDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMFundManagerMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMFundManagerVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMFundManagerMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicMauritiusDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerBDSwissVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerSwissMarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerSwissMarketsMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "AIPAMMAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "AIPAMMDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "AIPAMMMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "AIPAMMMauritiusDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerSwissMarketsVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMFundManagerVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PAMMSMVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicVanuatuDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondMauritiusDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "BondVanuatuDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "MAMSMMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "MAMSMVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "MAMMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "MAMVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "MAMAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5Account",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5DemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5MauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5MauritiusDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5VanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5VanuatuDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawBDSwissAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawBDSwissMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawBDSwissVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMauritiusAccountBDX",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PortfolioManagementAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "PortfolioManagementMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "CentMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "CentVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexPremiumMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexPremiumVanuatuAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicSkyGroundAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicSkyGroundDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicEquityFlowAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicEquityFlowAsiaAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicEquityFlowDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawEquityFlowAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "CentEquityFlowAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerEquityFlowAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicLydianAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicLydianDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicTauroMarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexMT5TauromarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicTauroMarketsAsiaAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicTauroMarketsDemoAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexRawTauroMarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "CentTauroMarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "IntroducingBrokerTauroMarketsAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    } | {
      // Account ID
      id: number | null,
      login: string | null,
      // Balance for this account
      balance: number | null,
      // Currency in which account is lead
      currency: Currency | null,
      metaTraderApiUrl: string | null,
      isArchived: boolean | null,
      hidden: boolean | null,
      // Account Subtype
      accountSubtype: AccountSubtype | null,
      // Swap Free account
      swapFree: boolean | null,
      __typename: "ForexClassicTauroMarketsMauritiusAccount",
      isDemo: boolean | null,
      symbolOverrides:  {
        symbol: string | null,
        marginDivider: number | null,
      } | null,
    }
  );
